import React, {Component} from 'react';
import ListingContainer from "../../containers/listing_container";
import {Button, Form, Grid, Header, Label, Message, Segment} from "semantic-ui-react";
import {COMPANY_API_URL} from "../../constants/api_routes";
import {getTemplateList} from "../../data/report_template_api";
import { getPriceLists } from '../../data/price_list_api';

class UpdateCompany extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateId: undefined,
            invoiceFrequency: undefined,
            templateIdValid: true,
            invoiceFrequencyValid: true,
            templates:[],
            showMessage:false,
            priority_tat:undefined,
            priceLists:[],
            selectedPriceList:undefined,
            pleaseConnectMe:undefined
            
        }
    }

    componentWillMount(){
        this.setState({selectedPriceList:this.props.selectedObject[0]['price_list_id'],templateId:this.props.selectedObject[0]['report_template_id'],invoiceFrequency:this.props.selectedObject[0]['invoice_frequency'] === 'daily'?'0':'1',priority_tat:this.props.selectedObject[0]["priority_tat"],pleaseConnectMe:this.props.selectedObject[0]["please_connect_me"]});
        getPriceLists().then((response)=>{  
            let newObj = [];
            for (let i = 0; i < response.priceData.length; i++) {
                let obj = {
                    key: response.priceData[i].id,
                    text: response.priceData[i].name,
                    value: response.priceData[i].id
                };
                newObj.push(obj);
            }
            this.setState({priceLists:newObj});
        })
        getTemplateList().then((response)=>{
            let newObj = [];
            for (let i = 0; i < response.length; i++) {
                let obj = {
                    key: response[i]['report_template'].id,
                    text: response[i]['report_template'].name,
                    value: response[i]['report_template'].id
                };
                newObj.push(obj);
            }
            this.setState({templates:newObj});
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (!this.state.templateId) {
            this.setState({templateIdValid: false});
            return
        }
        if (!this.state.invoiceFrequency) {
            this.setState({invoiceFrequencyValid: false});
            return
        }
        const formData = new FormData(event.target);
        formData.append("report_template_id", this.state.templateId);
        formData.append("invoice_frequency", this.state.invoiceFrequency);
        formData.append("priority_tat", this.state.priority_tat);
        if (this.state.selectedPriceList){
            formData.append("price_list", this.state.selectedPriceList);
        }
        formData.append("please_connect_me", this.state.pleaseConnectMe);
        this.props.updateDetails(COMPANY_API_URL, formData, this.props.selectedObject[0].id, this.successCallback);
    };

    successCallback = (response) => {
        if (response.success) {
            this.setState({showMessage:true});
            setTimeout(()=>{this.props.close()},3000);
        }
    };

    render() {
        const currentCompany = this.props.selectedObject[0];
        const templateOptions = this.state.templates;
        const invoiceFrequencyOption = [
            {key: 1, text: 'Daily', value: '0'},
            {key: 2, text: 'Monthly', value: '1'},
        ];

        return (
            <div>
                <Header as='h2' textAlign='center'>
                    Update "{currentCompany.name}" Company Details
                </Header>
                {this.state.showMessage && <Message positive onDismiss={() => {this.setState({showMessage:false})}}>
                    <Message.Header>
                        Company Updated successfully!
                    </Message.Header>
                </Message>}
                <Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Row stretched>
                        <Grid.Column width={8}>
                            <Segment style={{minHeight: '365px'}}>
                                <Label color='blue' ribbon>
                                    Company General details
                                </Label>
                                <p></p>
                                <Form.Input label="Company Name" fluid icon='user'placeholder='eg: Abc Inc, xyz Ltd'
                                            type='text' name="name" defaultValue={currentCompany.name}
                                            required/>
                                <Form.Input label="Company Email" fluid icon='at'
                                            placeholder='abc@xyz.com,mail@mail.com'  defaultValue={currentCompany.email}
                                            name="email" type="email" required/>
                                <Form.Input label='Point of contact' fluid icon='user' 
                                            placeholder='Contact Name'
                                            type='text' name="point_of_contact" defaultValue={currentCompany['point_of_contact']}
                                            required/>
                                <Form.Input label='Phone Number' fluid icon='mobile'
                                            placeholder='328659286'
                                            type='text' name="phone_number"
                                            defaultValue={currentCompany['phone_number']}
                                            required/>
                                <Form.Group widths={2} className="field">
                                    <Form.Dropdown
                                        label='Report Template'
                                        defaultValue={currentCompany['report_template_id']}
                                        required
                                        selection
                                        error={!this.state.templateIdValid}
                                        wrapSelection={false}
                                        options={templateOptions}
                                        upward
                                        placeholder='Select Template'
                                        onFocus={()=>this.setState({templateIdValid:true})}
                                        onChange={(e, option) => {
                                            this.setState({templateId: option.value})
                                        }}
                                    />
                                    <Form.Dropdown
                                        label='Invoice Frequency'
                                        required
                                        selection
                                        error={!this.state.invoiceFrequencyValid}
                                        wrapSelection={false}
                                        options={invoiceFrequencyOption}
                                        upward
                                        placeholder='Select frequency'
                                        defaultValue={currentCompany['invoice_frequency'] === 'daily' ? '0' : '1'}
                                        onFocus={()=>this.setState({invoiceFrequencyValid:true})}
                                        onChange={(e, option) => {
                                            this.setState({invoiceFrequency: option.value})
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group widths={2} className="field">
                                      <Form.Dropdown
                                        label='Price List'
                                        selection
                                        wrapSelection={false}
                                        options={this.state.priceLists}
                                        upward
                                        placeholder='Select Price List'
                                        defaultValue={this.state.selectedPriceList}
                                        onChange={(e, option) => {
                                            this.setState({selectedPriceList: option.value})
                                        }}
                                    />

                                      <Form.Dropdown
                                        label='Show Please Connect Me'
                                        selection
                                        required
                                        wrapSelection={false}
                                        options={[{ key: 'yes', text: 'Yes', value: true },{ key: 'no', text: 'No', value: false }]}
                                        upward
                                        placeholder='Select Price List'
                                        defaultValue={currentCompany['please_connect_me']}
                                        onChange={(e, option) => {
                                            this.setState({pleaseConnectMe: option.value})
                                        }}
                                    />
                                    </Form.Group>
                                <Form.Group widths={2} className="field">
                                    <Form.TextArea label="Send Invoice To" fluid icon='at' 
                                                placeholder='user@abc.com' defaultValue={currentCompany['email_invoice']}
                                                type='text' name="email_invoice"/>
                                    <Form.TextArea label="Send Report To" fluid icon='at' 
                                                placeholder='user@report.com' defaultValue={currentCompany['email_report']}
                                                type='text' name="email_report"/>
                                </Form.Group>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Company Address Details
                                </Label>
                                <p></p>
                                <Form.Input label='Address Line 1' fluid
                                            placeholder='Street'
                                            type='street view' name="line1" defaultValue={currentCompany.line1}
                                            required/>
                                <Form.Input label='Address Line 2' fluid
                                            placeholder='Landmark'
                                            type='street view' name="line2" defaultValue={currentCompany.line2}
                                />
                                <Form.Input label='Address Locality'
                                            placeholder='Region'
                                            type='text' name="locality" defaultValue={currentCompany.locality}
                                />
                                <Form.Input label='City' placeholder='City'
                                            type='text' name="city" defaultValue={currentCompany.city}
                                />
                                <Form.Input label='Country'
                                            placeholder='Country'
                                            type='text' name="country" defaultValue={currentCompany.country}
                                />
                                <Form.Input label='Post Code'
                                            placeholder='C2PN57'
                                            type='text' name="postcode" defaultValue={currentCompany.postcode}
                                            required
                                />
                            </Segment>
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Company Requirements
                                </Label>
                                <p></p>
                                <Form.Field>
                          <label>24 Hour Turnarnound</label>
                          <Button.Group>
                            <Button positive={this.state.priority_tat == true}
                              onClick={() =>
                                this.setState({ priority_tat: true})}>Yes</Button>
                            <Button.Or />
                            <Button negative={this.state.priority_tat == false}
                              onClick={() =>
                                this.setState({ priority_tat: false })} >No</Button>
                          </Button.Group>
                        </Form.Field>
                                <Form.Group widths={3} className="field">
                                    <Form.TextArea label="Booking Requirements" fluid icon='at'
                                                placeholder='Do not use XXX clerk...' defaultValue={currentCompany['booking_requirements']}
                                                type='text' name="booking_requirements"/>
                                    <Form.TextArea label="Report Requirements" fluid icon='at' 
                                                placeholder='No Tenant Cost on Check Outs...' defaultValue={currentCompany['report_requirements']}
                                                type='text' name="report_requirements"/>
                                    <Form.TextArea label="Agent Booking Requirements" fluid icon='at'
                                                placeholder='Agents see this when booking through system...' defaultValue={currentCompany['agent_booking_requirements']}
                                                type='text' name="agent_booking_requirements"/>
                                    </Form.Group>                 
                                    <div className="submit-buttons">
                                        <Button primary fluid>Update Company</Button>
                                    </div>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </div>
        );
    }
}

export default ListingContainer(UpdateCompany);


// WEBPACK FOOTER //
// ./src/views/company/update_company.js